export default "__VITE_ASSET__CojtvgAf__"